import React from "react";
import { Box, Link } from "@mui/material";
import { colors, fonts, gradients, layout } from "../../theme/tokens";
import teamMembers from "../../data/teamMembers";

const Team = () => {
  return (
    <Box
      component="section"
      sx={{ pt: "56px", pb: "80px", px: { xs: "20px", md: "28px" } }}
    >
      <Box sx={{ maxWidth: layout.maxWidth, mx: "auto" }}>
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: "42px" }}>
          <Box
            sx={{ display: "inline-flex", alignItems: "center", gap: "12px" }}
          >
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              LEADERSHIP
            </Box>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(28px,3.4vw,42px)",
              lineHeight: 1.1,
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            Meet our team
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: "16px",
              lineHeight: 1.65,
              color: colors.mutedText,
              maxWidth: "560px",
              mx: "auto",
              mt: "14px",
            }}
          >
            Experienced professionals committed to delivering exceptional value
            and results for every client.
          </Box>
        </Box>

        {/* Cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: "18px",
            maxWidth: "900px",
            mx: "auto",
          }}
        >
          {teamMembers.map((m) => (
            <Link
              key={m.id}
              href={`/team/${m.id}`}
              underline="none"
              sx={{
                background: "#fff",
                border: `1px solid ${colors.lineSoft}`,
                borderRadius: "24px",
                p: "30px",
                display: "flex",
                gap: "22px",
                alignItems: "flex-start",
                boxShadow: "0 18px 40px -32px rgba(14,27,42,.5)",
                transition: "transform .4s cubic-bezier(.2,.7,.2,1)",
                "&:hover": { transform: "translateY(-6px)" },
              }}
            >
              {/* Monogram */}
              <Box
                sx={{
                  width: "84px",
                  height: "84px",
                  borderRadius: "20px",
                  flex: "none",
                  background: gradients.navy,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: fonts.display,
                  fontWeight: 700,
                  fontSize: "28px",
                  color: "#fff",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {m.initials}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "5px",
                    background: gradients.amber,
                  }}
                />
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Box
                  component="h3"
                  sx={{
                    fontFamily: fonts.display,
                    fontWeight: 700,
                    fontSize: "20px",
                    color: colors.navyInk,
                    m: 0,
                  }}
                >
                  {m.name}
                </Box>
                <Box
                  sx={{
                    display: "inline-block",
                    fontFamily: fonts.body,
                    fontSize: "12.5px",
                    fontWeight: 600,
                    color: colors.amber,
                    background: "rgba(242,121,28,.1)",
                    p: "3px 12px",
                    borderRadius: "30px",
                    mt: "8px",
                  }}
                >
                  {m.role}
                </Box>
                <Box
                  sx={{
                    fontFamily: fonts.body,
                    fontSize: "14px",
                    lineHeight: 1.6,
                    color: "#6A7888",
                    mt: "14px",
                  }}
                >
                  {m.summary}
                </Box>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    mt: "16px",
                    fontFamily: fonts.body,
                    fontWeight: 700,
                    fontSize: "13.5px",
                    color: colors.steelBlue,
                  }}
                >
                  View full profile <Box component="span">→</Box>
                </Box>
              </Box>
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Team;
